module.exports = __webpack_public_path__ + "static/media/Header.7e4241f5.jpg";